import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
import { CSSRulePlugin } from 'gsap/all'

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(CSSRulePlugin);


function stickyHeader(){
	window.addEventListener('scroll', function() {
		if ( document.documentElement.scrollTop <= 20 ) {
			document.querySelector( 'body' ).classList.remove('scrolled')
			
			document.querySelector( '.top-nav .top-nav__logo-link' ).classList.add('pointer-events-auto')
			document.querySelector( '.top-nav .top-nav__logo-link' ).classList.remove('pointer-events-none')
			document.querySelector( '.top-nav--mobile .top-nav__logo-link' ).classList.add('pointer-events-auto')
			document.querySelector( '.top-nav--mobile .top-nav__logo-link' ).classList.remove('pointer-events-none')
		} else {
			document.querySelector( 'body' ).classList.add('scrolled')

			document.querySelector( '.top-nav .top-nav__logo-link' ).classList.remove('pointer-events-auto')
			document.querySelector( '.top-nav .top-nav__logo-link' ).classList.add('pointer-events-none')
			document.querySelector( '.top-nav--mobile .top-nav__logo-link' ).classList.remove('pointer-events-auto')
			document.querySelector( '.top-nav--mobile .top-nav__logo-link' ).classList.add('pointer-events-none')
		}
	});

	// Anchor links
	// Function to handle smooth scrolling for anchor links
	function smoothScroll(target, offset) {
		const element = document.querySelector(target);
	
		if (element) {
			window.scrollTo({
				top: element.offsetTop - offset,
				behavior: 'smooth'
			});
		}
	}
	
	// Event listener for anchor links
	let anchorLinks = document.querySelectorAll( '[data-scroll=scroll-to]' )

	anchorLinks.forEach(element => {
		element.addEventListener('click', function(event) {
			const target = event.target;
		
			event.preventDefault(); // Prevent default anchor link behavior
		
			let offset = 50; // Adjust this value to set the desired offset
			if ( target.getAttribute('data-scroll-space') ){
				offset = target.getAttribute('data-scroll-space')
			}
			smoothScroll(target.getAttribute('href'), offset); // Smooth scroll to the target element with an offset
		});
	});
}


// Toggles for boarding and societies pages
function boardingToggles() {
  if ( $('body').hasClass('page-template-boarding') || $('body').hasClass('page-template-societies')  ) {
    
    // Toggle list and grid view
    let gridViewBtn = $('.js-boarding-toggle-grid');
    let listViewBtn = $('.js-boarding-toggle-list');
    let returnBtn = $('.js-return-button');
    let gridViewDiv = $('.js-grid-view');
    let listViewDiv = $('.js-list-view');
    
    if ( gridViewBtn.hasClass('active') ) {
      gridViewBtn.hide();      
    }
    if ( listViewBtn.hasClass('active') ) {
      listViewBtn.hide();
    }
    gridViewBtn.on('click', function(e) {
      e.preventDefault();
      gridViewBtn.addClass('active');
      gridViewDiv.addClass('active');
      gridViewBtn.hide();
      gridViewDiv.show();
      listViewBtn.removeClass('active');
      listViewDiv.removeClass('active');
      listViewBtn.show();
      listViewDiv.hide();
    });
    listViewBtn.on('click', function(e) {
      e.preventDefault();
      listViewBtn.addClass('active');
      listViewDiv.addClass('active');
      listViewBtn.hide();
      listViewDiv.show();
      gridViewBtn.removeClass('active');
      gridViewDiv.removeClass('active')
      gridViewBtn.show();
      gridViewDiv.hide();
    });

    returnBtn.on('click', function(e) {
      e.preventDefault();
      listViewDiv.removeClass('active');
      listViewDiv.hide();
      gridViewDiv.addClass('active')
      gridViewDiv.show();
    });

    if ( gridViewDiv.hasClass('active') ) {
      gridViewDiv.show();      
      listViewDiv.hide();
    }
    if ( listViewDiv.hasClass('active') ) {
      listViewDiv.show();
      gridViewDiv.hide();
    }
  
    // Toggle house view
    $('.js-boarding-house').each(function(i){
      if ( $(this).hasClass('active') ) {
        $(this).show();
      } else {
        $(this).hide();
      }
    });


	// Back to the grid view scroll
	document.querySelectorAll('.js-boarding-toggle-grid--with-scroll')?.forEach(function(el) {
		el.addEventListener('click', function(e) {
			$([document.documentElement, document.body]).animate({
				scrollTop: $(".js-grid-view").offset().top - 50
			}, 800)
		})
	})

    $('.js-house-toggles a').on('click', function(e) {
      e.preventDefault();
      var href = $(this).attr('href');
      if ( $(this).hasClass('active') ) {
        // Do Nothing
      } else {
        listViewDiv.addClass('active');
        listViewBtn.hide();
        listViewDiv.show();
        gridViewBtn.removeClass('active');
        gridViewDiv.removeClass('active')
        gridViewBtn.show();
        gridViewDiv.hide();
        
        $('.js-house-toggles a').removeClass('active');
        $(this).addClass('active');
		$( '.js-house-toggles a[href="' + href + '"]' ).addClass('active')
        $('.js-boarding-house').removeClass('active');
        $('.js-boarding-house').hide();
        $(href).addClass('active');
        $(href).show();
        listViewBtn.addClass('active');

		$([document.documentElement, document.body]).animate({
			scrollTop: $(".js-list-view").offset().top - 50
		}, 800)
      }
    });


	/* On load checks if URL parameter is set to one specific item and opens that item */
	if ( window.location.href.indexOf('?item=') > -1 ) {
		let item = window.location.href.split('?item=')[1];
		let itemToggle = document.querySelector( '.js-house-toggles a[href="#' + item + '"]' );

		if ( itemToggle ) {
			itemToggle.click();
		}
	}
  }
}


function twoColumnsOneSticky() {
	const sections = gsap.utils.toArray('.two-columns-one-sticky');
	let prevHeight = document.body.offsetHeight;
	let scrollTriggers = [];

	function createScrollTriggers() {
		scrollTriggers.forEach(trigger => trigger.kill());
		scrollTriggers = [];

		sections.forEach((section) => {
			const large = section.querySelector('.scrolling-column');
			const stickyColumn = section.querySelector('.sticky-column');

			if (window.innerWidth > 827 && stickyColumn && stickyColumn.offsetHeight < window.innerHeight) {
				// Create new ScrollTrigger and store the instance
				const trigger = ScrollTrigger.create({
					trigger: large,
					pin: stickyColumn,
					pinSpacing: false,
					start: "top top",
					end: "bottom bottom",
					markers: false,
				});
				scrollTriggers.push(trigger);
			}
		});
	}

	createScrollTriggers();

	// Create ResizeObserver to watch for height changes.
	const resizeObserver = new ResizeObserver((entries) => {
		const currentHeight = document.body.offsetHeight;
		if (currentHeight !== prevHeight) {
			prevHeight = currentHeight;
			
			// Small delay to ensure DOM is updated
			setTimeout(() => {
				ScrollTrigger.refresh();
				createScrollTriggers();
			}, 100);
		}
	});

	// Start observing the body element
	resizeObserver.observe(document.body);
}


function parallaxWithSpeed(){
	// apply parallax effect to any element with a data-speed attribute
	let triggers = document.querySelectorAll( '[data-trigger]' )

	if ( triggers.length > 0 && window.innerWidth > 827 ){
		triggers.forEach(trigger => {
			let section = trigger.parentNode
		
			gsap.to("[data-speed]", {
				y: (i, el) => (-1 * parseFloat(el.getAttribute("data-speed"))) * (section.offsetHeight / 3),
				ease: "none",
				scrollTrigger: {
					trigger: trigger,
					invalidateOnRefresh: true,
					scrub: 0.4,
					//markers: true,
					start: 'center bottom'
				}
			});
		});
	}
}



function dottedLineAnimation(){
	const triggerOne = document.querySelector('.container-line-middle')
	const svgPathOne = CSSRulePlugin.getRule('.container-line-middle::before')

	if ( triggerOne ){
		const tl = gsap.timeline({
			scrollTrigger: {
				trigger: triggerOne,
				start: "top center",
				end: "bottom bottom-=100px",
				scrub: 1,
				//markers: true
			}
		});

		tl.fromTo( svgPathOne, { clipPath: 'inset(0% 0% 95% 0%)' }, { clipPath: 'inset(0% 0% 0% 0%)', duration: 4, ease: "none" } )
	}

	// Top line
	const topLine = CSSRulePlugin.getRule('.line-top::before')
	if ( topLine ) {
		gsap.set( svgPathOne, { opacity: 0 } )
		setTimeout(() => {
			gsap.fromTo( svgPathOne, { opacity: 0, clipPath: 'inset(0% 0% 100% 0%)' }, { opacity: 1, clipPath: 'inset(0% 0% 95% 0%)', duration: 1, ease: "none" } )
		}, 1200);
		gsap.fromTo( topLine, { clipPath: 'inset(0% 0% 100% 0%)' }, { clipPath: 'inset(0% 0% 0% 0%)', duration: 1, ease: "none" } )
	}

	// Admissions
	function animateAdmissionsDottedLine(){
		const triggerTwo = document.querySelector('.admissions-dotted-line')
		const svgPathTwo = CSSRulePlugin.getRule('.admissions-dotted-line::before')
	
		if ( triggerTwo ){
			const tl = gsap.timeline({
				scrollTrigger: {
					trigger: triggerTwo,
					start: "top center",
					end: "bottom bottom-=100px",
					scrub: 1,
					//markers: true
				}
			});
	
			tl.fromTo( svgPathTwo, { clipPath: 'inset(0% 0% 98% 0%)' }, { clipPath: 'inset(0% 0% 0% 0%)', duration: 4, ease: "none" } )
		}
	}

	// Detect AJAX call so the admissions animation works.
	(function() {
		var proxied = window.XMLHttpRequest.prototype.send;
		window.XMLHttpRequest.prototype.send = function() {
			var pointer = this
			var intervalId = window.setInterval(function(){
					if(pointer.readyState != 4){
							return;
					}
					
					animateAdmissionsDottedLine()

					clearInterval(intervalId);
			}, 1);
			return proxied.apply(this, [].slice.call(arguments));
		};
	})();
}



function oneWordPerLine(){
	// Split the title text into words
	const titles = document.querySelectorAll('.one-word-per-line');

	titles.forEach(title => {
		const titleText = title.textContent;
		const words = titleText.split(' ');
	
		// Clear the existing content of the title
		title.innerHTML = '';
	
		let currentLine = '';
		words.forEach((word, index) => {
			if (word === '&') {
				currentLine += ' ' + word;
			} else {
				if (currentLine !== '') {
					const span = document.createElement('div');
					span.textContent = currentLine;
					title.appendChild(span);
					currentLine = '';
				}
				if (index === 0) {
					currentLine = word;
				} else {
					const space = document.createTextNode(' ');
					title.appendChild(space);
					currentLine = word;
				}
			}
		});
	
		// Add the last line if there's content remaining
		if (currentLine !== '') {
			const span = document.createElement('div');
			span.textContent = currentLine;
			title.appendChild(span);
		}
	});

}


export { stickyHeader, boardingToggles, twoColumnsOneSticky, parallaxWithSpeed, dottedLineAnimation, oneWordPerLine };
